// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'moment'
import Vuelidate from "vuelidate";
import store from './store/store'
import BootstrapVue from 'bootstrap-vue'
import helpers from './mixins/helpers';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
//Vue.use(tesseract);
Vue.mixin(helpers);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  validations: {},
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js